import { createAction, createReducer } from "@reduxjs/toolkit";

export const setSchema = createAction('setSchema')
export const setTable = createAction('setTable')
export const setSelectedPool = createAction('setSelectedPool')
export const removeSelectedPool = createAction('removeSelectedPool')
export const resetToggleControl = createAction('resetToggleControl')


const initialState = {
    schema: "",
    table: "",
    selectedPool: []
};

export const toggleControl = createReducer(initialState, {
    [setSchema]: (state, action) => {
        return{
            table: state.table,
            schema: action.payload,
            selectedPool: []
        }
    },
    [setTable]: (state, action) => {
        return {
            table: action.payload,
            schema: state.schema,
            selectedPool: []
        }
    },
    [setSelectedPool]: (state, action) => {
        return {
            selectedPool: [...state.selectedPool, action.payload],
            schema: "",
            table: ""
        } 
    },
    [removeSelectedPool]: (state, action) => {
        return {
            selectedPool: state.selectedPool.filter(item => item !== action.payload)
        }
    },
    [resetToggleControl]: () => {
        return {
            selectedPool: [],
            schema: "",
            table: ""
        }
    }
}
);

//steps to update:
// need to change the import for all setSchema, setTable, resetSchema, resetTable
// need to update any useSelectors for: pool name button, tablebutton
// need to update the reset function in sign-in
// need to update the poolname button import and dispatch functions - done

